import { Button } from '@mui/material'
import React from 'react'

import { useMsal } from '@azure/msal-react'
import { getMatomoSurveyToolName, getSurveyImplementation } from 'src/constants';
import Storage from 'src/utils/storage/storage';
import _ from 'lodash';

function Survey() {
  const { accounts } = useMsal()
  const segmentDetailsStorage = Storage.getSegmentDetails();
  const country =
    !_.isEmpty(segmentDetailsStorage)
      ? segmentDetailsStorage?.source_name
      : '';


  const surveyImplementation = getSurveyImplementation(country);

  const MATOMO_SURVEY_TOOL_NAME = getMatomoSurveyToolName(country);


  let finalHREF = ''
  let finalAPIURL = ''

  const windowsUrl = window.location.href

  if (
    windowsUrl.includes(
      'mars-ppaanalyticedge-fe.cloud-effem.com'
    )
  ) {
    finalHREF = surveyImplementation.routePathProd
    finalAPIURL = surveyImplementation.apiUrlProd
  } else {
    finalHREF = surveyImplementation.routePathDev
    finalAPIURL = surveyImplementation.apiUrlDev
  }

  React.useEffect(() => {
    const handleSurvey = async () => {
      try {
        const response = await fetch(finalAPIURL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            tool: MATOMO_SURVEY_TOOL_NAME,
            user: accounts[0].username,
          }),
        })
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
      } catch (error) {
        console.log('Error occurred:', error)
      }
    }

    if (accounts.length > 0) {
      handleSurvey()
    }
  }, [accounts, finalAPIURL])

    return (
  <Button
      key='survey-btn'
      className='flex items-center px-4 h-[45px]'
      style={{
        background: '#FDBE0F',
        color: 'black',
        marginRight: '15px',
      }}
      href={finalHREF}
      target='_blank'
    >
      {surveyImplementation.title}
    </Button>
)

}

export default Survey
